export default function withNullOption<T>(
  label: string,
  options: Array<T> | undefined
) {
  return [{ value: null, label }, ...(options || [])];
}
